var _path, _path2, _path3, _path4, _rect, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignIcon1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4151 2.58213C14.1965 3.3635 14.1965 4.63036 13.4151 5.41173C12.6338 6.1931 11.3669 6.1931 10.5855 5.41173C9.80417 4.63036 9.80417 3.3635 10.5855 2.58213C10.9608 2.2069 11.4697 1.99609 12.0003 1.99609C12.531 1.99609 13.0399 2.2069 13.4151 2.58213",
    stroke: "#FAFDFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99756 9.99914L10.5895 5.40723",
    stroke: "#FAFDFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4106 5.40723L18.0026 9.99914",
    stroke: "#FAFDFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2485 17.2524L13.75 13.751",
    stroke: "#FAFDFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.99658,
    y: 9.99951,
    width: 18.0075,
    height: 11.0046,
    rx: 2,
    stroke: "#FAFDFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1994 13.6009C10.1993 13.6561 10.1545 13.7009 10.0993 13.7008C10.0441 13.7008 9.99931 13.6561 9.99929 13.6008C9.99926 13.5456 10.044 13.5008 10.0992 13.5008C10.1258 13.5007 10.1513 13.5113 10.1701 13.5301C10.1889 13.5488 10.1994 13.5743 10.1994 13.6009",
    stroke: "#FAFDFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0011 17.4027C14.0011 17.4579 13.9563 17.5026 13.901 17.5026C13.8458 17.5026 13.8011 17.4578 13.801 17.4026C13.801 17.3474 13.8457 17.3026 13.901 17.3025C13.9275 17.3025 13.953 17.313 13.9718 17.3318C13.9906 17.3506 14.0012 17.3761 14.0011 17.4027",
    stroke: "#FAFDFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignIcon1);
export default __webpack_public_path__ + "static/media/campaign-icon-1.8ea94a74b3602dcf61799c2f174110c9.svg";
export { ForwardRef as ReactComponent };